// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientSummaryPrescription {
    static getAttributeTypeMap() {
        return MangoHubGetPatientSummaryPrescription.attributeTypeMap;
    }
}
MangoHubGetPatientSummaryPrescription.discriminator = undefined;
MangoHubGetPatientSummaryPrescription.additionalProperties = false;
MangoHubGetPatientSummaryPrescription.attributeTypeMap = [
    {
        "name": "drugName",
        "baseName": "drugName",
        "type": "string"
    },
    {
        "name": "strength",
        "baseName": "strength",
        "type": "string"
    },
    {
        "name": "usageForm",
        "baseName": "usageForm",
        "type": "string"
    },
    {
        "name": "dosage",
        "baseName": "dosage",
        "type": "string"
    },
    {
        "name": "daySupply",
        "baseName": "daySupply",
        "type": "number"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "number"
    },
    {
        "name": "prescribedDate",
        "baseName": "prescribedDate",
        "type": "Date"
    },
];
//# sourceMappingURL=mangoHubGetPatientSummaryPrescription.js.map